import { Account } from "../interfaces/Account";

const getAccountFullName = (account: Account): string => {
  const organizationFullName = account?.organization?.fullName;
  const individualFullName = [
    account?.individual?.lastName,
    account?.individual?.firstName,
    account?.individual?.middleName,
  ]
    .filter(Boolean)
    .join(" ");
  return organizationFullName || individualFullName || String(account?.id) || "";
};

export default getAccountFullName;
